/// <reference path="../account/contracts/contracts.ts"/>
/// <reference path="../infrastructure/contracts/contracts.ts"/>
/// <reference path="../common/contracts/contracts.ts"/>

module cr.entity
{
    entityModule = angular.module("cr.entity", ["cr.account", "cr.infrastructure", "cr.common", "ui.tree"]);
}
